import * as types from './mutation-types'

export default {
    [types.SET_BUSINESS](state, business) {
        state.business = business
    },
    [types.SET_BUSINESS_PERMISSION](state, data) {
        state.allBusinessPermission.push(data)
    },
    [types.CHECK_BUSINESS_PERMISSION](state, data) {
        console.log(data)
        console.log(state.allBusinessPermission.includes(data))
        if (state.allBusinessPermission.includes(data)){
            state.getBusinessPermission=true
        }else{
            state.getBusinessPermission = false
        }
    },
    [types.FALSE_BUSINESS_PERMISSION](state, data) {
        state.getBusinessPermission = false
    },
    
}
